import { useFilters } from '@/platform/hooks/useFilters';
import { Pagination } from '@/platform/ui';

const CustomPagination = ({ meta, only = [] }) => {
    const { filters, updateFilters } = useFilters(only);

    if (!meta?.last_page || meta?.last_page < 2) {
        return null;
    }

    return (
        <Pagination
            currentPage={filters?.page || 1}
            totalPages={meta?.last_page}
            onPageChange={page => updateFilters('page', page)}
        />
    );
};

export default CustomPagination;
